
export const setDirectives = (app) => {
  app.directive('click-outside', {
    bind(el, binding, vnode) {
      el.eventHandler = (event) => {
        if (!el.contains(event.target)) {
          vnode.context[binding.expression](event); // 触发绑定的方法
        }
      };
      document.addEventListener('click', el.eventHandler);
    },
    unbind(el) {
      document.removeEventListener('click', el.eventHandler);
    }
  });
}